import { useNavigate } from "react-router-dom";
import logo from '../assets/images/main_logo.png';
import img_no from "../assets/images/notfound.gif";

function NotFound() {
    const navigate = useNavigate();

    return (
        <div className="w-100 h-100">
            <img className="notfoundlogo-st" src={logo} alt="not found" />
            <div className="notfound-st">
                <div className="d-center flex-column setmaxwdht-nfst">
                    <img src={img_no} alt="not found" className="w-100 h-100" />
                </div>

                <button className="gotohomee-st" onClick={() => navigate("/")}>Go To home</button>
            </div>
        </div>
    );
}

export default NotFound;